/**
 * Authorization Roles
 */
const authRoles = {
  admin: ['administrator'],
  hr: ['hr'],
  user: ['user'],
  pr: ['pr'],
  top: ['top'],
  employee: ['employee'],
  manager: ['manager'],
  AttendanceReportAll: ['AttendanceReportAll'],
  onlyGuest: [],
  CEO: ['CEO'],
  tester: ['tester'],
};

export default authRoles;
